import Masonry from 'react-masonry-css'

import styles from './SearchImages.module.css'
import { UnsplashLinks } from './UnsplashLinks'
import { UNSPLASH_SERVICE } from '../../constants'
import type { GraphImage, IntegrationsService } from '../../types'

export type HandleImageCallback = (image: GraphImage) => void

export const ImagesLayout = ({
  images,
  service,
}: {
  images: GraphImage[]
  service: IntegrationsService
}): JSX.Element => {
  return (
    <Masonry
      breakpointCols={{
        default: 3,
        880: 2,
        596: 1,
      }}
      className={styles.masonryGrid}
      columnClassName="unsplah-masonry-column"
    >
      {images &&
        images.length > 0 &&
        images.map((image) => (
          <div className="gallery-item" key={image.id}>
            <button
              className={styles.invisibleButton}
              data-testid="integrations-gallery-item-button"
              type="button"
              onClick={() => {
                if (service.onFileSelected !== undefined)
                  service?.onFileSelected(image)
              }}
            >
              <img
                data-testid="ideas-images-layout-image"
                key={image.id}
                src={image.thumbnailUrl}
                alt={image.description || ''}
              />
            </button>
            {service?.id === UNSPLASH_SERVICE && (
              <UnsplashLinks imageLinked={image} />
            )}
          </div>
        ))}
    </Masonry>
  )
}
